import { render, staticRenderFns } from "./EmployeeSizeInformationCreateOrUpdate.vue?vue&type=template&id=2fbf6c6a&"
import script from "./EmployeeSizeInformationCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./EmployeeSizeInformationCreateOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports